 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_Cover'
 import A1_UTHOR from '@/components/01_uthor'
 import A2_TITLE from '@/components/02_title'
 import A3_DED from '@/components/03_ded'
 import A4_MAPS from '@/components/04_maps'
 import A5_COPYRIGHT from '@/components/05_copyright'
 import A6_INT from '@/components/06_int'
 import A7_PREFACE from '@/components/07_preface'
 import A8_PREFACE1 from '@/components/08_preface1'
 import A9_TOC from '@/components/09_toc'
 import A0_ILLUSTRATION from '@/components/10_illustration'
 import A1_CHART from '@/components/11_chart'
 import A2_TEXT from '@/components/12_text'
 import A3_PART1 from '@/components/13_part1'
 import A4_CH1 from '@/components/14_ch1'
 import A5_CH2 from '@/components/15_ch2'
 import A6_CH3 from '@/components/16_ch3'
 import A8_CH4 from '@/components/18_ch4'
 import A9_PART2 from '@/components/19_part2'
 import A0_CH5 from '@/components/20_ch5'
 import A1_CH6 from '@/components/21_ch6'
 import A2_CH7 from '@/components/22_ch7'
 import A3_PART3 from '@/components/23_part3'
 import A4_CH8 from '@/components/24_ch8'
 import A5_CH9 from '@/components/25_ch9'
 import A6_APPENDIX from '@/components/26_appendix'
 import A7_APPENDIX01 from '@/components/27_appendix01'
 import A8_INDEX from '@/components/28_index'
 import A9_THEMAPS from '@/components/29_themaps'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/00_Cover",
 			"name" : "00_Cover",
 			"component" : A0_COVER
 		},
 		{
 			"path" : "/01_uthor",
 			"name" : "01_uthor",
 			"component" : A1_UTHOR
 		},
 		{
 			"path" : "/02_title",
 			"name" : "02_title",
 			"component" : A2_TITLE
 		},
 		{
 			"path" : "/03_ded",
 			"name" : "03_ded",
 			"component" : A3_DED
 		},
 		{
 			"path" : "/04_maps",
 			"name" : "04_maps",
 			"component" : A4_MAPS
 		},
 		{
 			"path" : "/05_copyright",
 			"name" : "05_copyright",
 			"component" : A5_COPYRIGHT
 		},
 		{
 			"path" : "/06_int",
 			"name" : "06_int",
 			"component" : A6_INT
 		},
 		{
 			"path" : "/07_preface",
 			"name" : "07_preface",
 			"component" : A7_PREFACE
 		},
 		{
 			"path" : "/08_preface1",
 			"name" : "08_preface1",
 			"component" : A8_PREFACE1
 		},
 		{
 			"path" : "/09_toc",
 			"name" : "09_toc",
 			"component" : A9_TOC
 		},
 		{
 			"path" : "/10_illustration",
 			"name" : "10_illustration",
 			"component" : A0_ILLUSTRATION
 		},
 		{
 			"path" : "/11_chart",
 			"name" : "11_chart",
 			"component" : A1_CHART
 		},
 		{
 			"path" : "/12_text",
 			"name" : "12_text",
 			"component" : A2_TEXT
 		},
 		{
 			"path" : "/13_part1",
 			"name" : "13_part1",
 			"component" : A3_PART1
 		},
 		{
 			"path" : "/14_ch1",
 			"name" : "14_ch1",
 			"component" : A4_CH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js